import { render, staticRenderFns } from "./ManageAthleteCard.vue?vue&type=template&id=3d70fef3&scoped=true&"
import script from "./ManageAthleteCard.vue?vue&type=script&lang=ts&"
export * from "./ManageAthleteCard.vue?vue&type=script&lang=ts&"
import style0 from "./ManageAthleteCard.vue?vue&type=style&index=0&id=3d70fef3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d70fef3",
  null
  
)

export default component.exports